export default __webpack_public_path__ + "static/media/acme-1-logo-png-transparent.ec28e860.png";